import { render, staticRenderFns } from "./HealthQuestionnaire.vue?vue&type=template&id=7a1ec7cc&"
import script from "./HealthQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./HealthQuestionnaire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports